var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dont-have-account"},[_vm._v(" "+_vm._s(_vm.$t('signIn.dontHaveAccount__text'))+" "),_c('router-link',{attrs:{"to":{path: '/sign-up', query: _vm.routeQuery}}},[_c('span',{staticClass:"underline-animate"},[_vm._v(" "+_vm._s(_vm.$t('signUp.signUp__text'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }